import React from "react";

const ProjectsPage = () => { 

    return (
        <div>
            <h2>Projects</h2>
            <p>This is the Projects page for BobTheSkull.</p>
        </div>
    );
}


export default ProjectsPage;